import React from 'react';
import { TinyButton as ScrollUpButton } from 'react-scroll-up-button';

export function Tweetboard({ tweets }) {
  return (
    <div>
      <div
        className="tweet-info"
        style={{
          position: 'absolute',
          maxWidth: '60%',
          margin: '120px 0px 2px 2px',
        }}
      >
        {Object.keys(tweets)
          .reverse()
          .map((key) => {
            const tweet = tweets[key];
            return <Tweet key={key} tweet={tweet} />;
          })}
      </div>
      <div
        className="tweet-image"
        style={{
          position: 'absolute',
          maxWidth: '40%',
          margin: '120px 0px 0px 60%',
        }}
      >
        {Object.keys(tweets)
          .reverse()
          .map((key) => {
            return tweets[key];
          })
          .filter((tweet) => {
            if (!tweet.entities) return false;
            if (!tweet.entities.media) return false;
            if (!tweet.entities.media[0]) return false;
            return true;
          })
          .map((tweet) => {
            return <TweetImage tweet={tweet} />;
          })}
      </div>
    </div>
  );
}

function Tweet({ tweet }) {
  const time = parseTwitterDate(tweet.created_at).toString();
  return (
    <div
      style={{
        background: 'white',
        borderRadius: 4,
        color: 'black',
        marginTop: 10,
        display: 'flex',
        cursor: 'pointer',
        maxWidth: '100%',
      }}
      className="tweet"
      onClick={() =>
        (window.location.href =
          'https://twitter.com/' +
          tweet.user.screen_name +
          '/status/' +
          tweet.id_str)
      }
    >
      <img
        src={tweet.user.profile_image_url_https}
        style={{
          display: 'block',
          objectFit: 'contain',
          padding: 5,
          borderRadius: 50,
          maxWidth: '100%',
          height: '100%',
          verticalAlign: 'middle',
        }}
      />

      <div
        style={{
          padding: 5,
          background: 'white',
          minWidth: '50%',
          borderRadius: 4,
        }}
        className="tweet-text"
      >
        <div style={{ wordWrap: 'break-word' }}>
          <strong>{tweet.user.name}</strong>{' '}
        </div>
        <div>
          <small>@{tweet.user.screen_name}</small>
        </div>
        <div style={{padding: '5px 0px', borderBottom: 'solid 1px #F5F5F5', minWidth: '100%'}}>
          <small style={{color: '#686868'}}>{time}</small>
        </div>
        <div style={{ paddingTop: 10, wordWrap: 'break-word' }}>
          {tweet.text}
        </div>
      </div>
    </div>
  );
}

function TweetImage({ tweet }) {
  return (
    <div
      style={{ overflow: 'hidden', textAlign: 'center', marginTop: 10 }}
      className="tweet"
    >
      <img
        src={tweet.entities.media[0].media_url_https}
        className="tweet-image"
        style={{
          maxWidth: '100%',
          padding: 5,
          borderRadius: '2%',
          cursor: 'pointer',
        }}
        onClick={() =>
          (window.location.href =
            'https://twitter.com/' +
            tweet.user.screen_name +
            '/status/' +
            tweet.id_str)
        }
      />
      <ScrollUpButton
        EasingType="easeInQuart"
        ShowAtPosition={100}
        AnimationDuration={500}
      />
    </div>
  );
}

function parseTwitterDate(tdate) {
  const systemDate = new Date(tdate);
  const userDate = new Date();
  const diff = Math.floor((userDate - systemDate) / 1000);
  if (diff <= 1) {
    return 'just now';
  }
  if (diff < 20) {
    return diff + ' seconds ago';
  }
  if (diff < 40) {
    return 'half a minute ago';
  }
  if (diff < 60) {
    return 'less than a minute ago';
  }
  if (diff <= 90) {
    return 'one minute ago';
  }
  if (diff <= 3540) {
    return Math.round(diff / 60) + ' minutes ago';
  }
  if (diff <= 5400) {
    return '1 hour ago';
  }
  if (diff <= 86400) {
    return Math.round(diff / 3600) + ' hours ago';
  }
  if (diff <= 129600) {
    return '1 day ago';
  }
  if (diff < 604800) {
    return Math.round(diff / 86400) + ' days ago';
  }
  if (diff <= 777600) {
    return '1 week ago';
  }
  return systemDate.toLocaleString("en-SG",{timeZone: "Asia/Bangkok"});
}

export default Tweetboard;
